import { ref } from "vue"
export const enableAntialiasing = ref(false);